const urlParams = new URLSearchParams(window.location.search);

// Extract the token from the query parameters
const token = urlParams.get("token");
// console.log(token); // Logs the token value correctly

// const token = "4216|2gfcYnvfIV5K4YMe5DVGKQAArD7x81I6c1Z7B9AL88471619";
export const RoleEvent = async () => {
  try {
    const response = await fetch(
      "https://sh8afchat.com/api/charge-events/role-events",
      {
        method: "get", // You can also specify POST if needed
        headers: {
          "Content-Type": "application/json", // Add any necessary content type headers
          Authorization: `Bearer ${token}`, // Use the token passed to the function
          "Custom-Header": "YourCustomHeaderValue", // Add any other custom headers if needed
        },
      },
    );

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();
    return data; // Return the parsed JSON data
  } catch (error) {
    throw new Error(error.message); // Handle errors if the request fails
  }
};

export const fetchTargets = async () => {
  try {
    const response = await fetch(
      "https://sh8afchat.com/api/charge-events/targets",
      {
        method: "get", // You can also specify POST if needed
        headers: {
          "Content-Type": "application/json", // Add any necessary content type headers
          Authorization: `Bearer ${token}`, // Use the token passed to the function
          "Custom-Header": "YourCustomHeaderValue", // Add any other custom headers if needed
        },
      },
    );

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();
    return data; // Return the parsed JSON data
  } catch (error) {
    throw new Error(error.message); // Handle errors if the request fails
  }
};
export const fetchRating = async () => {
  try {
    const response = await fetch(
      "https://sh8afchat.com/api/charge-events/top-daily-chargers",
      {
        method: "get", // You can also specify POST if needed
        headers: {
          "Content-Type": "application/json", // Add any necessary content type headers
          Authorization: `Bearer ${token}`, // Use the token passed to the function
          "Custom-Header": "YourCustomHeaderValue", // Add any other custom headers if needed
        },
      },
    );

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    console.log(response);
    const data = await response.json();
    return data; // Return the parsed JSON data
  } catch (error) {
    throw new Error(error.message); // Handle errors if the request fails
  }
};
export const fetchWeeklyRating = async () => {
  try {
    const response = await fetch(
      "https://sh8afchat.com/api/charge-events/top-monthly-chargers",
      {
        method: "get", // You can also specify POST if needed
        headers: {
          "Content-Type": "application/json", // Add any necessary content type headers
          Authorization: `Bearer ${token}`, // Use the token passed to the function
          "Custom-Header": "YourCustomHeaderValue", // Add any other custom headers if needed
        },
      },
    );

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();
    return data; // Return the parsed JSON data
  } catch (error) {
    throw new Error(error.message); // Handle errors if the request fails
  }
};

export const fetchEventDetails = async () => {
  try {
    const response = await fetch(
      "https://sh8afchat.com/api/event-periods/details",
      {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    );

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const fetchEventTopUsers = async () => {
  try {
    const response = await fetch(
      "https://sh8afchat.com/api/event-periods/top-users",
      {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    );

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const fetchEventRewards = async () => {
  try {
    const response = await fetch(
      "https://sh8afchat.com/api/event-periods/rewords",
      {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    );

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw new Error(error.message);
  }
};
